import React from 'react';

interface FilterBarProps {
  onFilterClick: (filterType: string) => void;
  onTuneClick: () => void;
}

const FilterBar: React.FC<FilterBarProps> = ({ onFilterClick, onTuneClick }) => {
  return (
    <section className="flex gap-stack-md overflow-x-auto no-scrollbar pb-2 md:hidden">
      <button
        className="flex items-center gap-1 px-4 py-2 bg-surface-container rounded-full border border-outline-variant hover:bg-surface-container-low transition-colors"
        onClick={() => onFilterClick('tier')}
      >
        <span className="font-label-bold text-label-bold text-primary">Tier</span>
        <span className="material-symbols-outlined text-[16px]">expand_more</span>
      </button>
      <button
        className="flex items-center gap-1 px-4 py-2 bg-surface-container rounded-full border border-outline-variant hover:bg-surface-container-low transition-colors"
        onClick={() => onFilterClick('rating')}
      >
        <span className="font-label-bold text-label-bold text-primary">Rating</span>
        <span className="material-symbols-outlined text-[16px]">expand_more</span>
      </button>
      <button
        className="flex items-center gap-1 px-4 py-2 bg-surface-container rounded-full border border-outline-variant hover:bg-surface-container-low transition-colors"
        onClick={() => onFilterClick('availability')}
      >
        <span className="font-label-bold text-label-bold text-primary">Availability</span>
        <span className="material-symbols-outlined text-[16px]">expand_more</span>
      </button>
      <button
        className="flex items-center justify-center w-10 h-10 bg-primary text-on-primary rounded-full shrink-0"
        onClick={onTuneClick}
      >
        <span className="material-symbols-outlined text-[20px]">tune</span>
      </button>
    </section>
  );
};

export default FilterBar;
